<template>
  <div class="d-flex justify-content-center align-items-center" :style="`height:${height}`">
    <div v-if="!loading">
      <div class="Box-root Padding-all--48">
        <div class="nc-icon">
          <div class="nc-icon-body">
            <i class="mdi mdi-magnify font-size-24"></i>
          </div>
        </div>
        <div class="result-text-body">
          <span class="result-text">{{ $t('components.no-content.title') }}</span>
        </div>
        <div class="result-subtext-body">
          <span class="result-subtext">{{ $t('components.no-content.subtitle') }}</span>
        </div>
      </div>
    </div>
    <b-spinner v-else type="grow" label="Spinning" variant="primary"/>
  </div>
</template>

<script>
export default {
  name: "NoContent",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '350px'
    }
  }
}
</script>

<style scoped>
.no-content {
  height: 350px !important;
}

.no-content p {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -40px;
  z-index: 9999;
}

.nc-icon {
  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(64,68,82,0.08),0 1px 1px 0 rgba(0,0,0,0.12);
  overflow: hidden;
  background-color: #fff;
  box-sizing: border-box;
  display: inline-block;
}
.nc-icon-body{
  padding: 8px 12px 6px 12px;
  background-color: rgb(246,248,250);
  box-sizing: border-box;
}
.result-text-body {
  padding-top: 20px;
  box-sizing: border-box;
}
.result-text{
  white-space: normal;
  line-height: 28px;
  font-weight: 700;
  font-size: 20px;
  display: inline;
  color: rgb(26,27,37);
}
.result-subtext-body{
  padding-top: 4px;
  box-sizing: border-box;
}
.result-subtext {
  color: rgb(106,115,131);
  white-space: normal;
  font-size: 14px;
  display: inline;
  line-height: 20px;
}
</style>